import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import DataListBodyRow from '../../../../../../components/data-list/data-list-body/data-list-body-row/index';
import DataListBody from '../../../../../../components/data-list/data-list-body';
import UserList from "./components/user-list";
import './index.css';

function UsersListContent () {

	const [roles, setRoles] = useState({});
	const [isUpdatingRole, setIsUpdatingRole] = useState({});

	const findUsers = useSelector(state => state.usersListReducer.findUsers);
	const enteredSearchValue = useSelector(state => state.contactsGroupItemReducer.getEnteredSearchValue);
	const enteredCollaboratorSearchValue = useSelector(state => state.sharingDetailsReducer.enteredCollaboratorSearchValue);

	const { t } = useTranslation();

	useEffect(() => {
		if (findUsers) {
			const initialRoles = findUsers.users.reduce((acc, user) => {
				acc[user.id] = user.role;
				return acc;
			}, {});
			setRoles(initialRoles);

			const isUpdatingRoles = findUsers.users.reduce((acc, user) => {
				acc[user.id] = false;
				return acc;
			}, {});
			setIsUpdatingRole(isUpdatingRoles);
		}
	}, [findUsers]);

	const handleRoleChange = (userId, newRole) => {
		setRoles(prevRoles => ({
			...prevRoles,
			[userId]: newRole,
		}));
	};

	const handleRoleUpdate = (userId, roleUpdate) => {
		setIsUpdatingRole(prevRoleUpdate => ({
			...prevRoleUpdate,
			[userId]: roleUpdate,
		}));
	};

	return (
		<DataListBody className="users">
			{
				findUsers !== null
					?
					findUsers.users.length > 0
					?
						enteredCollaboratorSearchValue !== ""
						?
							enteredSearchValue !== ""
							?
								findUsers.users.map(collaborator => {
									if(collaborator.name.toLowerCase().includes(enteredCollaboratorSearchValue.toLowerCase())){
										if(collaborator.labels.length > 0){

											let collaboratorArray = [];

											collaborator.labels.forEach(label => {
												if(label.name.toLowerCase().includes(enteredSearchValue.toLowerCase())){
													collaboratorArray = collaboratorArray.concat(collaborator);
												}
											});

											if(collaboratorArray.length > 0){
												return collaboratorArray.map( collaboratorArrayItem => (
													<UserList newRole={roles[collaborator.id]} onRoleChange={handleRoleChange} isUpdatingRole={isUpdatingRole[collaborator.id]} onRoleUpdate={handleRoleUpdate} key={collaborator.id} collaborator={collaboratorArrayItem} />
												))
											} else {
												return null;
											}

										} else {
											return null;
										}
									} else {
										return null;
									}
								})
							:
								findUsers.users.map(collaborator => {
									if(collaborator.name.toLowerCase().includes(enteredCollaboratorSearchValue.toLowerCase())){
										return <UserList newRole={roles[collaborator.id]} onRoleChange={handleRoleChange} isUpdatingRole={isUpdatingRole[collaborator.id]} onRoleUpdate={handleRoleUpdate} key={collaborator.id} collaborator={collaborator} />
									} else {
										return null;
									}
								})
						:
							enteredSearchValue !== ""
							?
								findUsers.users.map(collaborator => {
									if(collaborator.labels.length > 0){

										let collaboratorArray = [];

										collaborator.labels.forEach(label => {
											if(label.name.toLowerCase().includes(enteredSearchValue.toLowerCase())){
												collaboratorArray = collaboratorArray.concat(collaborator);
											}
										});

										if(collaboratorArray.length > 0){
											return collaboratorArray.map( collaboratorArrayItem => (
												<UserList newRole={roles[collaborator.id]} onRoleChange={handleRoleChange} isUpdatingRole={isUpdatingRole[collaborator.id]} onRoleUpdate={handleRoleUpdate} key={collaborator.id} collaborator={collaboratorArrayItem} />
											))
										} else {
											return null;
										}

									} else {
										return null;
									}
								})
							:
								findUsers.users.map(collaborator => {
									return <UserList newRole={roles[collaborator.id]} onRoleChange={handleRoleChange} isUpdatingRole={isUpdatingRole[collaborator.id]} onRoleUpdate={handleRoleUpdate} key={collaborator.id} collaborator={collaborator} />
								})
					:
						<DataListBodyRow><em>{t("textNoCollaborator")}</em></DataListBodyRow>
				:
					<DataListBodyRow><em>{t("textNoCollaborator")}</em></DataListBodyRow>
			}
		</DataListBody>
	)

}

export default UsersListContent;
